import React from "react";
import LegalLayout from "../components/site/LegalLayout";
import { COMPANY } from "../data/site";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Refund Policy" eyebrow="Legal" testId="refund-page">
      <p>
        This Refund Policy explains how refunds are processed for transactions
        carried out on JayesPay, operated by {COMPANY.legalName}.
      </p>

      <h2>1. Successful Transactions</h2>
      <p>
        Successful recharges, bill payments, PAN applications, RD installments
        and similar services that have been delivered as per operator/biller
        confirmation are non-refundable.
      </p>

      <h2>2. Failed Transactions</h2>
      <p>
        If an amount is deducted from your wallet but the service fails at the
        operator/biller end, the amount is automatically credited back to the
        same wallet, typically within minutes. If it does not reflect within 24
        hours, please raise a support ticket from within the app.
      </p>

      <h2>3. Wallet Top-up Refunds</h2>
      <p>
        For wallet top-ups via UPI / Bank Transfer / Instant UPI, if the amount
        is debited from your bank but not credited to your JayesPay wallet, the
        amount is auto-reversed by the payment partner within 5 – 7 business
        days as per RBI norms.
      </p>

      <h2>4. Package Purchases</h2>
      <p>
        Service-activation packages are non-refundable once activated, as the
        services they unlock are made available immediately.
      </p>

      <h2>5. Refund Method</h2>
      <p>
        Refunds, where applicable, are processed to the original payment source
        (wallet or bank account registered in Bank Master).
      </p>

      <h2>6. Disputes</h2>
      <p>
        Raise a support ticket within 7 days of the transaction. Include the
        transaction ID, date, amount and a brief description. Our team will
        investigate and revert within 7 – 10 business days.
      </p>

      <h2>7. Contact</h2>
      <p>
        For refund-related help, write to{" "}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> or call{" "}
        {COMPANY.phone}.
      </p>
    </LegalLayout>
  );
}
